import { Injectable } from '@angular/core';
import { groupBy, isValidDate } from '@zipari/web-utils';
import { DisplayDay } from './calendar.model';

const total_days = 7;

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  public currentMonth: number;
  public currentYear: number;
  public displayDays: DisplayDay[];

  generateDays(data: any, prop: string) {
    const currentMonthDates = this.createDaysForMonth(
      this.currentMonth,
      this.currentYear,
    );
    const currentMonthStartDay = this.getWeekday(
      this.currentMonth,
      this.currentYear,
      1,
    );
    const currentMonthEndDay = this.getWeekday(
      this.currentMonth,
      this.currentYear,
      currentMonthDates.length,
    );

    const previousMonthDates: DisplayDay[] = [
      ...Array(currentMonthStartDay),
    ].map(() => ({
      date: null,
      dayOfTheMonth: null,
      dateString: null,
      isCurrentMonth: false,
    }));

    const nextMonthDates: DisplayDay[] = [
      ...Array(total_days - (currentMonthEndDay + 1)),
    ].map(() => ({
      date: null,
      dayOfTheMonth: null,
      dateString: null,
      isCurrentMonth: false,
    }));

    const groupedData = groupBy(data, prop);

    this.displayDays = [
      ...previousMonthDates,
      ...currentMonthDates,
      ...nextMonthDates,
    ];

    this.displayDays = this.displayDays.map((displayDay) => {
      if (!displayDay.data) displayDay.data = [];
      if (groupedData[displayDay.dateString]) {
        displayDay.data.push(...groupedData[displayDay.dateString]);
      }

      return displayDay;
    });

    return this.displayDays;
  }

  getNumberOfdaysInMonth(month: number, year: number) {
    // # of days in a month (0 represents last day of previous month)
    return new Date(year, month, 0).getDate();
  }

  createDaysForMonth(month: number, year: number): DisplayDay[] {
    return [...Array(this.getNumberOfdaysInMonth(month, year))].map(
      (_, index) => {
        const doubleDigits = 10;
        const updatedMonth = month < doubleDigits ? `0${month}` : month;
        const updatedDay =
          index + 1 < doubleDigits ? `0${index + 1}` : index + 1;

        return {
          date: new Date(`${year}-${month}-${index + 1} 00:00`),
          dateString: `${year}-${updatedMonth}-${updatedDay}`,
          dayOfTheMonth: index + 1,
          isCurrentMonth: true,
        };
      },
    );
  }

  // returns 0-6
  getWeekday(month: number, year: number, day: number) {
    let tmpDate = new Date(`${year}-${month}-${day} 00:00`);

    // Safari doesn't support YYYY-MM-DD format. So confirm that date is valid
    if (!isValidDate(`${year}-${month}-${day} 00:00`)) {
      tmpDate = new Date(`${year}/${month}/${day} 00:00`);
    }

    return tmpDate.getDay();
  }
}
